import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
    CmpsCardComponentModule,
    CmpsCardHeaderRowComponentModule,
    CmpsScorecardCategoryModule,
    CmpsScorecardPillarInformationModule,
    CmpsScorecardRankBonusModule,
    CmpsScoreCardScoreSectionModule,
    CmpsScorecardSubHeaderModule,
} from '@cmps/ng-kit';
import {
    CmpsButtonModule,
    CmpsIconModule,
    CmpsIconRegistry,
} from '@cmps/ng-uikit';
import { mdiLaunch } from '@mdi/js';

import { CmpsCommonModule } from '../common/common.module';
import { CmpsLazyI18nModule } from '../i18n/i18n.module';
import { ScorecardService } from '../scorecard/core/scorecard.service';
import { CmpsScorecardModule } from '../scorecard/scorecard.module';
import { CmpsWidgetModule } from '../widget/widget.module';

import { MyScorecardComponent } from './my-scorecard.component';
import { TranslationIdMap } from './my-scorecard.i18n';

@NgModule({
    imports: [
        CommonModule,
        CmpsCommonModule,
        CmpsCardComponentModule,
        CmpsCardHeaderRowComponentModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsWidgetModule,
        CmpsScorecardSubHeaderModule,
        CmpsScorecardRankBonusModule,
        CmpsScorecardCategoryModule,
        CmpsScorecardPillarInformationModule,
        CmpsScoreCardScoreSectionModule,
        BrowserAnimationsModule,
        CmpsIconModule,
        CmpsScorecardModule,
        CmpsButtonModule,
    ],
    declarations: [MyScorecardComponent],
    exports: [MyScorecardComponent],
    providers: [ScorecardService],
})
export class CmpsMyScorecardModule {
    constructor(
        private readonly _domSanitizer: DomSanitizer,
        private readonly _iconRegistry: CmpsIconRegistry,
    ) {
        [['launch', mdiLaunch]].forEach(([name, icon]) => {
            _iconRegistry.addSvgIconFromHtml(
                name,
                _domSanitizer.bypassSecurityTrustHtml(
                    `<svg id="${name}"><path d="${icon}"></path></svg>`,
                ),
                '__internal',
            );
        });
    }
}
